export const prefix = "@@tyro/";


export const TYRO_CANCEL_TRANSACTION = `${prefix}CANCEL_TRANSACTION`;
export const TYRO_PAIR_TERMINAL = `${prefix}PAIR_TERMINAL`;
export const TYRO_RESET_MODAL = `${prefix}RESET_MODAL`;
export const TYRO_RESET_STATUS = `${prefix}RESET_STATUS`;
export const TYRO_SET_ERROR_STATUS = `${prefix}SET_ERROR_STATUS`;
export const TYRO_SET_MESSAGE_STATUS = `${prefix}SET_MESSAGE_STATUS`;
export const TYRO_SET_MODAL_STATUS = `${prefix}SET_MODAL_STATUS`;
export const TYRO_SET_QUESTION_STATUS = `${prefix}SET_QUESTION_STATUS`;
export const TYRO_SET_QUESTION_ANSER = `${prefix}SET_QUESTION_ANSWER`;
export const TYRO_STATUS_COMPLETE = `${prefix}STATUS_COMPLETE`;
export const TYRO_STATUS_ERROR = `${prefix}STATUS_ERROR`;
export const TYRO_STATUS_MESSAGE = `${prefix}STATUS_MESSAGE`;
export const TYRO_STATUS_QUESTION = `${prefix}STATUS_QUESTION`;